export const calculateDv = nit => {
  const v = [3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71];
  let x = 0;
  let y = 0;

  const nitReversed = nit.split("").reverse().join("");

  for (let i = 0; i < nitReversed.length; i++) {
    y = nitReversed.substring(i, i + 1);
    x += parseInt(y, 10) * v[i];
  }

  y = x % 11;

  if (y > 1) {
    return 11 - y;
  }

  return y;
};

export const validateNit = nit => {
  if (!nit || typeof nit !== "string") {
    return false;
  }

  const cleanNit = nit.replace(/[ .,-]/g, "");

  const nitWithoutDv = cleanNit.slice(0, -1);
  const dv = cleanNit.slice(-1);

  if (nitWithoutDv.length === 0) {
    return false;
  }

  const dvCalculated = calculateDv(nitWithoutDv).toString();

  return dv === dvCalculated;
};
